import { Routes, Route } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { Dashboard } from "./pages/Dashboard";
import { CheckIn } from "./pages/CheckIn";
import { Settings } from "./pages/Settings";
import { AuditLog } from "./pages/AuditLog";
import { Chat } from "./pages/Chat";
import { Layout } from "./components/Layout";
import Login from "./pages/Login";

function App() {
  const {
    isLoading,
    isAuthenticated,
    loginWithRedirect,
    logout,
    handleRedirectCallback,
    user,
    error,
  } = useAuth0();

  // Handle Auth0 redirect callback
  useEffect(() => {
    const handleAuthCallback = async () => {
      if (window.location.search.includes("code=") || window.location.search.includes("state=")) {
        console.log("Auth0: Handling redirect callback");
        try {
          await handleRedirectCallback();
          console.log("Auth0: Callback handled successfully");
        } catch (error) {
          console.error("Auth0 callback error:", error);
        }
      }
    };

    handleAuthCallback();
  }, [handleRedirectCallback]);

  // Debug authentication state
  useEffect(() => {
    console.log("Auth0 state:", { isLoading, isAuthenticated, user: user?.email, error });
  }, [isLoading, isAuthenticated, user, error]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-red-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login onLogin={loginWithRedirect} />;
  }

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <Layout onLogout={handleLogout}>
      <Routes>
        <Route path="/" element={<Chat />} />
        <Route path="/journey" element={<Dashboard />} />
        <Route path="/checkin" element={<CheckIn />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/audit" element={<AuditLog />} />
      </Routes>
    </Layout>
  );
}

export default App;
